export default __webpack_public_path__ + "b75a03ac70b35a457d8887fd0f574e9f.png";